<div
  class="group relative flex flex-col p-8 border-2 rounded-3xl cursor-pointer transition-all duration-300 ease-out h-full"
  [class.border-primary-9]="selected()"
  [class.bg-primary-2]="selected()"
  [class.dark:bg-primary-a3]="selected()"
  [class.shadow-xl]="selected()"
  [class.shadow-primary-a3]="selected()"
  [class.bg-white]="!selected()"
  [class.dark:bg-neutral-2]="!selected()"
  [class.border-neutral-3]="!selected()"
  [class.dark:border-neutral-4]="!selected()"
  [class.hover:border-neutral-5]="!selected()"
  [class.dark:hover:border-neutral-5]="!selected()"
  [class.hover:bg-neutral-2]="!selected()"
  [class.dark:hover:bg-neutral-3]="!selected()"
  [class.opacity-50]="disabled()"
  [class.cursor-not-allowed]="disabled()"
>
  @if (icon()) {
    <div
      class="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110 duration-300"
      [class.bg-primary-9]="selected()"
      [class.text-white]="selected()"
      [class.bg-primary-3]="!selected()"
      [class.dark:bg-primary-a3]="!selected()"
      [class.text-primary-11]="!selected()"
    >
      <mat-icon class="w-7! h-7! text-[28px]" [class.text-white!]="selected()">{{ icon() }}</mat-icon>
    </div>
  }

  <div class="flex flex-col flex-grow">
    <span class="text-xl font-bold text-neutral-12 mb-2">{{ label() }}</span>

    @if (description()) {
      <p class="text-sm text-neutral-10 dark:text-neutral-11 leading-relaxed mb-4">
        {{ description() }}
      </p>
    }

    <!-- Optional extra content -->
    <div class="mt-auto">
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Checkmark indicator -->
  <div
    class="absolute top-6 right-6 transition-all duration-300 transform"
    [class.scale-100]="selected()"
    [class.opacity-100]="selected()"
    [class.scale-0]="!selected()"
    [class.opacity-0]="!selected()"
  >
    <mat-icon class="text-primary-9 w-8! h-8! text-[32px]">check_circle</mat-icon>
  </div>
</div>
